import { ShopCurrency } from "./shop-currency";
import { SystemField } from "./system-field";

export class CurrencySheet extends SystemField { 
    label?:string;
    ordering?:number;
    shop_currency_id?:string;
    image?:string;
    value?:string;

    // relationship
    shop_currency?:ShopCurrency;
}
